export default Object.freeze({
  PROPERTIES: '00',
  DETAILS: '01',
  PROPERTIES_MANDATES: '03',
  PROPERTIES_MANDATES_SPECIFIC: '04',
  PROPERTIES_MANDATES_DOCUMENTS: '05',
});
